var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_98_418",
    transform: "matrix(0.0416667 0 0 0.0436508 0 -0.0238095)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_98_418",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGJSURBVEiJrZa7SkNBEIa/lYARCdFC0MZoKkmVPoWVL6CVbyN5EUurVIKVIILvoK2k0yKHI5gEQ8Yis7qZ7OZ6BgYyt3+Y+Te7BxEhpUADeADGgBgda6wxD8MpUFSccx3gHLgBRiZcUv+ziFylMEoB2D5QM/EL4A54SdR3gGvnXNP430WkB+BX0QL6zK5hXe0DLRFhSzs2gXJqzDWkrJh/K7oFKsBZQQ3eFHM+yUVISHIF+CwI90BEvgDsuR8wTdYTkAX2q6q3M80JawZTmKZB1ySfAu3AvlT1dltzwppuiOlPkRe7ol2gF9hjVS89zUli2AYfxq6aBlZ6mpPEWDTBHpM9pyTTnCTGogbVJRrYCVZa0ToTrLSiwieIcbCI5I05yJk+ml7GGtuMA5n8A/NIg1xjG3Hgi2M8ZCYnilEKDRHJnXNDYFtddefcEf9vxUmQXnbOHQL1wDcUkelpIw+9vY++g98/qrHYzD0Uu4sAHo29YyYuJWKx2ugENeCeyVfEsm/wSGuOLd4vPVs2cqbiWVQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon3);
export default __webpack_public_path__ + "static/media/delete-icon3.8b22f5733d532a4a55005d4e75a01821.svg";
export { ForwardRef as ReactComponent };